export const OFFSETS_CSS = `
  [data-string-offsets-item] {
    position: absolute;
    top: 0;
    left: 0;
    overflow: visible;
    pointer-events: none;
  }

  [data-string-offsets-item][data-visible="false"] {
    display: none;
  }

  [data-string-offsets-box],
  [data-string-offsets-zone],
  [data-string-offsets-marker] {
    top: 0;
    left: 0;
    box-sizing: border-box;
    will-change: transform;
  }

  [data-string-offsets-box],
  [data-string-offsets-zone] {
    position: absolute;
    pointer-events: none;
  }

  [data-string-offsets-marker] {
    position: absolute;
    pointer-events: none;
  }

  [data-string-offsets-marker][data-visible="false"] {
    display: none;
  }

  [data-string-offsets-marker][hidden] {
    display: none !important;
  }

  [data-string-offsets-box] {
    background: transparent;
    border: 1px dashed rgba(113, 113, 113, 1);
  }

  [data-string-offsets-item][data-inview="true"] [data-string-offsets-box] {
    border-color: rgba(17, 17, 17, 0.38);
  }

  [data-string-offsets-zone] {
    border: 1px dashed rgba(17, 17, 17, 0.14);
    background-color: rgb(255 255 255 / 30%);
    background-image: repeating-linear-gradient(135deg, rgb(17 17 17 / 26%) 0px, rgba(17, 17, 17, 0.035) 2px, rgba(255, 255, 255, 0) 2px, rgba(255, 255, 255, 0) 8px);
  }

  [data-string-offsets-zone][data-edge="top"],
  [data-string-offsets-zone][data-edge="bottom"] {
    border-color: rgba(17, 17, 17, 0.16);
  }

  [data-string-offsets-zone][data-empty="true"] {
    opacity: 0.7;
  }

  [data-string-offsets-marker] {
    padding: 4px 6px 4px 4px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1px;
    white-space: nowrap;
    color: #111111;
    background-color: rgba(255, 255, 255, 1);
    opacity: 1;
  }

  [data-string-offsets-marker] svg {
    width: 10px;
    height: 10px;
    display: block;
    flex: 0 0 auto;
  }

  [data-string-offsets-marker-value] {
    display: block;
    font-size: 10px;
    line-height: 1;
    font-weight: 500;
  }

  [data-string-offsets-marker][data-empty="true"] {
    opacity: 0.56;
  }
`;
